// createActualSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createActualApiCall } from "../../Api/api";

// Define an initial state for the slice
const initialState = {
   data: null,
   loading: false,
   error: null,
};

export const createActualAsync = createAsyncThunk(
   "create-actual/create",
   async ({ data, err, done }) => {
      try {
         const response = await createActualApiCall(data);
         if (response.status === 200) {
            done && done();
            return response.data;
         } else {
            err && err();
         }
      } catch (error) {
         // You can customize the error handling here
         err && err();
         throw error.response.data;
      }
   }
);

// Create a slice of the Redux store
const createActualSlice = createSlice({
   name: "create-actual",
   initialState,
   reducers: {},
   extraReducers: (builder) => {
      builder
         .addCase(createActualAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
         })
         .addCase(createActualAsync.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
         })
         .addCase(createActualAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
         });
   },
});

// Export the reducer
export default createActualSlice.reducer;
